module.exports = __webpack_public_path__ + "img/sub31.7d39a88d.jpg";